module.exports = __webpack_public_path__ + "img/economy-report.63766f85.svg";